import { FC, useEffect, useState } from "react";
import { UseTranslationContext } from "../Context/TranslationContext";

interface FormToggleProps {
    translationValueLeft: string;
    translationValueRight: string;
    translationTitle: string;
    cssClass : string;
    defaultValueState: boolean;
    id: string;
    valueUpdateCallback(onState : boolean): void;
}

const FormToggleElementDualChoice: FC<FormToggleProps> = (props) => {

    const [toggleState, setToggleState] = useState(props.defaultValueState?"on":"off");

    const ToggleValue = () => {
        toggleState == 'off'?setToggleState('on'):setToggleState('off');
    };

    const ToggleValueForced = (e: any) => {
        e.target.value == 'off'?setToggleState('off'):setToggleState('on');
    }

    useEffect(() => {
        props.valueUpdateCallback(toggleState == 'off'?false:true);
      }, [toggleState]);

      useEffect(() => {
        setToggleState(props.defaultValueState?"on":"off");
      }, [props.defaultValueState]);


    return (
        <>
            <div id={props.id} className={props.cssClass}>
                <p aria-hidden="true" className="label-toggle">{props.translationTitle}</p>
                <div className="toggle-container">
                    <label className="radio-button-field w-radio" htmlFor="r-gime-temps-plein">
                        <span tabIndex={0} aria-hidden="true" className={toggleState=='off' ? "text-toggle actif w-form-label" : "text-toggle w-form-label"}>{props.translationValueLeft}</span>
                    </label>
                    <input onClick={(e) => ToggleValueForced(e)} type="radio" id="r-gime-temps-plein" value="off" aria-label="Part time" className="w-form-formradioinput radio-button-toggle w-radio-input" />
                    <div id="toggle-container" onClick={ToggleValue} className={toggleState=='off' ? "toggle-appearance off disable" : "toggle-appearance"}>
                        <div className="toggle"></div>
                    </div>
                    <label className="radio-button-field w-radio" htmlFor="r-gime-temps-partiel">
                        <span tabIndex={0} aria-hidden="true" className={toggleState=='on' ? "text-toggle actif w-form-label" : "text-toggle w-form-label"}>{props.translationValueRight}</span>
                    </label>
                    <input onClick={(e) => ToggleValueForced(e)} type="radio" id="r-gime-temps-partiel" value="on" aria-label="Full time" className="w-form-formradioinput radio-button-toggle w-radio-input" />
                </div>
            </div>
        </>
    );
}

export default FormToggleElementDualChoice;